
import { Component, Vue, Ref } from 'vue-property-decorator'
import KatexText from '@/components/atoms/KatexText.vue'
import DrawingArea from '@/components/molecules/DrawingArea.vue'
import TogglePenControl from '@/components/organisms/study/TogglePenControl.vue'
import { PenSetting } from '@/const/PenSetting'
import { DrawingModel } from '@/models/DrawingModel'
import MyScriptMath from '@/api/external/MyScriptMath'
import MyScriptText from '@/api/external/MyScriptText'

/**
 * 手書き入力のサンプル
 */
@Component({
  components: {
    KatexText,
    DrawingArea,
    TogglePenControl,
  },
})
export default class DrawSample extends Vue {
  /**
   * 手書きタグの情報
   */
  @Ref()
  drawingArea!: DrawingArea

  /** ペン選択 */
  @Ref()
  togglePenControl!: TogglePenControl

  /** ペン情報 */
  private activePen = PenSetting.PEN_BLACK

  /** ストローク情報 */
  public strokes: DrawingModel.Stroke[] = []

  /** 手書き入力変換(数式) */
  private myScriptMath: MyScriptMath = new MyScriptMath()

  /** 手書き入力変換(日本語) */
  private myScriptText: MyScriptText = new MyScriptText()

  /** 数式変換した結果 */
  private resultMath: string = ''

  /** 日本語変換した結果 */
  private resultText: string = ''

  /**
   * 画面の読み込み時処理
   */
  private async created(): Promise<void> {
    this.$loading.start()
    this.$logger.log('===== 初期処理実行')

    this.$loading.complete()
  }

  /**
   * ペンの切り替え
   *
   * @param activePen アクティブなペン
   */
  private togglePen(activePen: DrawingModel.PenAsset): void {
    this.activePen = activePen
  }

  /**
   * ストロークの消去
   */
  private clearStrokes(): void {
    this.strokes.splice(0)
    // キャンバスの再描画
    this.drawingArea.drawAllStrokes()
  }

  /**
   * 手書き情報を数式に変換
   */
  private async recognizeMath(): Promise<void> {
    this.$loading.start()

    const result = await this.myScriptMath.recognize(
      this.drawingArea.getCanvasWidth(),
      this.drawingArea.getCanvasHeight(),
      this.strokes
    )
    if (result) {
      this.resultMath = result
    }

    this.$loading.complete()
  }

  /**
   * 手書き情報を日本語文字列に変換
   */
  private async recognizeText(): Promise<void> {
    this.$loading.start()

    const result = await this.myScriptText.recognize(
      this.drawingArea.getCanvasWidth(),
      this.drawingArea.getCanvasHeight(),
      this.strokes
    )
    if (result) {
      this.resultText = result
    }

    this.$loading.complete()
  }

  /**
   * テスト用のウェイト処理
   *
   * @param ms ミリ秒
   */
  private async sleep(ms: number): Promise<void> {
    await new Promise((resolve) => setTimeout(resolve, ms))
  }
}
